import type { Narrative } from '@/pages/Narrative/hooks/useNarrative';
import NarrativeVoting from '@/pages/Narrative/components/NarrativeVoting';
import { CreateAnnouncement } from '@/pages/Narrative/components/CreateAnnouncement';
import { CommentNarrative } from '../CommentNarrative';
import { SetFairValue } from '../SetFairValue';
import { useRef } from 'react';

type Props = {
  narrative: Narrative;
  onCommentClick: () => void;
};

export const NarrativeActions = ({ narrative, onCommentClick }: Props) => {
  const { id, slug, company, voteCount } = narrative;
  const containerRef = useRef<HTMLDivElement>(null);

  if (!company) return null;

  return (
    <div className="flex w-full items-center justify-start gap-2">
      <SetFairValue
        companyId={company.id}
        narrativeId={id}
        containerRef={containerRef}
        primaryNarrativeCount={narrative.primaryCount}
        isPrimary={narrative.isPrimary}
      />
      <NarrativeVoting
        narrativeId={id}
        slug={slug}
        upVotes={voteCount.upvotes}
      />
      <CommentNarrative
        commentKey={narrative.commentKey}
        onCommentClick={onCommentClick}
      />
      <CreateAnnouncement id={id} slug={slug} />
    </div>
  );
};
